import { AnyAction } from 'redux';
import {
  SUGGESTED_PRODUCTS_RECEIVED
} from '../constants';
import { SuggestedProduct } from '../Types/SuggestedProduct';


export interface SuggestedProductsState {
    sliderIntervalInSec?: number;
    products: SuggestedProduct[]
}

const DEFAULT_STATE: SuggestedProductsState = {
    products: []
};

export const suggestedProducts = (state = DEFAULT_STATE, action: AnyAction): SuggestedProductsState => {
  switch (action.type) {
    case SUGGESTED_PRODUCTS_RECEIVED:
       return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};